import { Analytics } from '@vercel/analytics/react'
import AppBundle from './routes/AppBundle'

export default function App() {
  return (
    <>
      <AppBundle />
      <Analytics />
    </>
  )
}
